import debug from 'debug';
import DictionaryObject from 'Global/Shared/Components/Sitecore/DictionaryObject';
import Breakpoints from 'Minetilbud/Shared/Components/Breakpoints/Breakpoints';
import DateHelper from 'Minetilbud/Shared/Components/Date/DateHelper';
import Feature from 'Minetilbud/Shared/Components/feature/feature';
import PriceHelper from 'Minetilbud/Shared/Components/Price/PriceHelper';

const log = debug('InspirationTextFeed:Templates');
const breakpoints = new Breakpoints();
const Price = new PriceHelper();

class Templates {
	constructor() {
		this.dictionary = new DictionaryObject({
			dictionaryUrl: 'Forum_dk/InspirationPages',
			includeDescendants: false
		});
	}

	cropTitle(title) {
		let characters = 15;
		let elipsis = '';

		if (breakpoints.MediaBreakpointUp('md')) {
			characters = 25;
		}

		if (breakpoints.MediaBreakpointUp('lg')) {
			characters = 30;
		}

		if (title.length > characters) {
			elipsis = '&#8230;';
		}

		return title.substring(0, characters) + elipsis;
	}

	/**
	 * @returns {Promise}
	 */
	async initDictionary() {
		return this.dictionary.Get();
	}

	/**
	 * @param {Object} options
	 * @param {number} options.priceBefore
	 */
	priceBefore({ priceBefore }) {
		log('price before', priceBefore);
		if (priceBefore !== undefined && priceBefore !== null) {
			const priceHelper = new PriceHelper();
			const formattedPrice = priceHelper.Format(priceBefore);
			
			return `<div class="o-inspiration-text-feed__price-before">${this.dictionary.Text('beforePrice')} ${formattedPrice}</div>`;
		}

		if (Feature.isEnabled('web-force-before-price')) {
			return `<div class="o-inspiration-text-feed__price-before">${this.dictionary.Text('beforePrice')} 1985,-</div>`;
		}

		return `<div class="o-inspiration-text-feed__price-before"></div>`;
	}

	priceSavings(pricePercentage) {
		if (pricePercentage === 0) return '';

		return `<div class="o-inspiration-text-feed__price-savings">Spar ${Math.floor(pricePercentage)}%</div>`;
	}

	/**
	 * @param {Object} options
	 * @param {number} options.price
	 * @param {number} options.savings
	 */
	priceSavingsSplash({ price, savings }) {
		if (savings > 0 || Feature.isEnabled('web-force-before-price')) {
			return `<div class="o-inspiration-text-feed__price-savings-splash">spar ${savings === 0 && Feature.isEnabled('web-force-before-price') ? 38 : Math.floor(savings) }%</div>`;
		}

		return '';
	}

	/**
	 * @param {Object} options 
	 * @param {boolean} options.carousel
	 * @param {Object} options.product
	 */
	product({ carousel, product }) {
		const priceType = product.price > 0 ? product.isMinimumPrice ? 'fra' : 'kr.' : '&nbsp;';
		const dateHelper = new DateHelper();
		const validDate = product.showDate ? dateHelper.Format(product.validFrom) + '-' + dateHelper.Format(product.validTo) : '';

		if(Feature.isEnabled('web-before-price-inspiration-text-feed')) {
			return `
			<a href="${product.advertUrl}" class="o-inspiration-text-feed__product ${carousel ? 'swiper-slide' : ''}">
				<div class="o-inspiration-text-feed__image-outer-wrapper">
					${this.priceSavingsSplash({ price: product.price, savings: product.pricePercentage })}
					<div class="o-inspiration-text-feed__image-wrapper">
						${this.productImage(product.imageUrl, product.title)}
					</div>
				</div>
				<div class="o-inspiration-text-feed__info-wrapper">
					<div class="o-inspiration-text-feed__title">${this.cropTitle(product.title)}</div>
					<div class="o-inspiration-text-feed__price">${priceType} ${Price.Format(product.price)}</div>
					${this.priceBefore({ priceBefore: product.priceBefore })}
					<div class="o-inspiration-text-feed__valid">${validDate}</div>
				</div>
			</a>
		`;
		}

		return `
			<a href="${product.advertUrl}" class="o-inspiration-text-feed__product ${carousel ? 'swiper-slide' : ''}">
				<div class="o-inspiration-text-feed__image-wrapper">
					${this.productImage(product.imageUrl, product.title)}
				</div>
				<div class="o-inspiration-text-feed__info-wrapper">
					<div class="o-inspiration-text-feed__title">${this.cropTitle(product.title)}</div>
					<div class="o-inspiration-text-feed__price">${Price.Format(product.price)}</div>
					${this.priceSavings(product.pricePercentage)}
				</div>
			</a>
		`;
	}

	productImage(imageUrl, altText) {
		const scale = window.devicePixelRatio;
		let imageSize = 95;

		if (breakpoints.MediaBreakpointUp('md')) {
			imageSize = 150;
		}

		if (breakpoints.MediaBreakpointUp('lg')) {
			imageSize = 170;
		}

		const url = `${imageUrl}?w=${imageSize * scale}&h=${imageSize * scale}`;

		return `<img class="o-inspiration-text-feed__image" width="${imageSize}" height="${imageSize}" src="${url}" alt="${altText}" />`;
	}
}

export default Templates;
